import {
  container,
  title,
  main,
  whiteColor,
  grayColor,
  primaryColor,
  mainRaised,
  hexToRgb
} from 'assets/jss/material-kit-pro-react.js'
import { colors } from '@material-ui/core'
// import { cardTitle } from 'assets/jss/material-kit-pro-react'

const presentationStyle = {
  '@global': {
    '#skeleton-background span': {
      borderRadius: 0,
      lineHeight: 'unset'
    }
  },
  main: {
    ...main
    /* overflow: "hidden" */
  },
  mainRaised,
  parallax: {
    overflow: 'hidden'
  },
  container: {
    ...container,
    zIndex: 1
  },
  title: {
    color: grayColor[1],
    textDecoration: 'none',
    fontWeight: '900',
    padding: 0,
    marginBottom: '25px',
    minHeight: '32px',
    fontFamily: "'Crimson Text, serif'"
  },
  infoContainer: {
    background: '#fafafa',
    marginBottom: '30px'
  },
  cardTitle: {
    '&, & a': {
      ...title,
      marginTop: '.825rem',
      marginBottom: '0.75rem',
      minHeight: 'auto',
      fontSize: '1.3rem',
      fontFamily: "'Crimson Text, serif'"
    }
  },
  companyCardtext: {
    textAlign: 'left'
  },
  cardTitleSmall: {
    ...title,
    marginTop: '20px',
    marginBottom: '15px',
    minHeight: 'auto',
    fontSize: '1.4rem',
    fontFamily: "'Crimson Text, serif'"
  },
  brand: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  proBadge: {
    position: 'relative',
    fontSize: '22px',
    textTransform: 'uppercase',
    fontWeight: '700',
    right: '-10px',
    padding: '10px 18px',
    top: '-30px',
    background: whiteColor,
    borderRadius: '3px',
    lineHeight: '22px',
    boxShadow: '0 5px 5px -2px rgba(' + hexToRgb(grayColor[25]) + ',.4)'
  },
  sectionButton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  cardBodyContainer: {
    width: '100%',
    padding: '0 30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  chipPrimary: {
    margin: '0px 5px',
    backgroundColor: '#09A963',
    '&:hover, &:active, &:focus': {
      backgroundColor: '#00663A'
    }
  },
  map: {
    padding: 0
  },
  contentContainer: {
    width: '100%',
    padding: '15px',
    marginTop: '-13px',
    marginLeft: 0,
    marginRight: 0,
    backgroundColor: colors.grey[50],
    marginBottom: 50
  },
  menuContainer: {
    width: '100%'
  },
  menuContainerMobile: {
    width: '100%',
    backgroundColor: '#fffffff7'
  },
  mainMenu: {
    marginTop: '40px',
    textAlign: 'center'
  },
  menuButtonPadding: {
    padding: '30px 15px 10px'
  },
  mainMenuMobile: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // overflowX: 'scroll',
    // paddingBottom: '16px',
    // marginTop: '10px',
    padding: '12px 12px 22px 12px'
  },
  menuButtonMobilePadding: {
    padding: '20px 15px 2px 17px'
  },
  mobileMenu: {
    paddingTop: 14,
    paddingBottom: 22,
    height: 'auto'
  },
  mobileMenuSelected: {
    color: '#09a963 !important'
  },
  lotContainer: {
    paddingTop: '36px',
    paddingBottom: '30px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '0 10px',
    marginTop: '-13px',
    marginLeft: 0,
    marginRight: 0,
    backgroundColor: colors.grey[50]
  },
  contentGrid: {
    padding: '0',
    paddingBottom: '5px',
    marginBottom: '15px',
    borderBottom: '1px solid #fff'
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '0 30px',
    marginBottom: '50px'
  },
  companyCard: {
    background: '#fafafa',
    margin: 0,
    boxShadow: '0'
  },
  cardContainerMobile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '0 0px',
    marginBottom: '87px'
  },
  cardDescription: {
    color: colors.grey[600]
  },
  alignCenter: {
    padding: 0,
    alignSelf: 'center',
    width: 'auto'
  },
  imgContainer: {
    marginTop: '-0px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '200px'
    // pointerEvents: 'none',
    // boxShadow: '0 5px 15px -8px rgba(0, 0, 0, 0.24), 0 8px 10px -5px rgba(0, 0, 0, 0.2)'
  },
  textInfo: {
    color: primaryColor[0],
    fontWeight: 800,
    marginLeft: 15
  },
  roundedCircle: {
    borderRadius: '50%',
    border: '10px solid rgba(255,255,255,0.3)'
  },
  bodySection: {
    margin: 0,
    padding: 0,
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  notFoundContainer: {
    width: '70%',
    height: '50vh',
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat'
  },
  h1Text: {
    color: '#024289',
    lineHeight: 1,
    fontWeight: 'bold',
    fontFamily: "'Poppins', sans-serif",
    zIndex: 12,
    textTransform: 'uppercase'
  },
  cardMedia: {
    height: 300,
    width: 300
  },
  cardMediaAdditionalImage: {
    height: '70%',
    width: '100%'
  },
  cardMediaMobile: {
    width: '100%',
    height: 'auto'
  },
  boldText: {
    color: colors.grey[4],
    fontWeight: 800
  },
  warningAlert: {
    borderRadius: 6,
    backgroundColor: '#fff39c',
    padding: '12px 16px'
  },
  masonryWrapper: {
    display: 'flex',
    flexFlow: 'column wrap',
    alignContent: 'center',
    // height: '1900px',
    counterReset: 'items',
    width: '100%',
    '&::before': {
      content: '',
      flexBasis: '100%',
      width: 0,
      order: 2
    },
    '&::after': {
      content: '',
      flexBasis: '100%',
      width: 0,
      order: 2
    }
  },
  masonryItem: {
    width: '48%',
    margin: 10,
    // '&::before': {
    //   counterIncrement: 'items',
    //   content: 'counter(items)'
    // },
    '&:nth-child(2n+1)': {
      order: 1
    },
    '&:nth-child(2n)': {
      order: 2
    }
  },
  textEllipsisMobile: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: '150px',
    whiteSpace: 'nowrap'
  },
  textEllipsis: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: '350px',
    whiteSpace: 'nowrap'
  },
  allergenePositiveCell: {
    backgroundColor: '#ffcdd2',
    borderLeft: '1px solid #e3e3e3',
    fontStyle: 'italic',
    fontWeight: 'bold'
  },
  allergeneNegativeCell: {
    backgroundColor: '#fff',
    borderLeft: '1px solid #e3e3e3'
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center'
  },
  videoWrapper: {
    position: 'relative',
    paddingBottom: '56.25%', /* 16:9 */
    height: 0
  },
  videoWrapperFrame: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  }
}

export default presentationStyle
